export default __webpack_public_path__ + "static/media/spp-1.e053e274.png";